import { createSlice } from '@reduxjs/toolkit';

const auditSlice = createSlice({
  name: 'audit',
  initialState: {
    audits: [],
    auditDetails: null, // Store specific audit details
    loading: false,
    error: null,
    reportStatus: null, // Add field to track the report submission status
  },
  reducers: {
    setAudits(state, action) {
      state.audits = action.payload;
    },
    setUserAudits: (state, action) => {
      state.userAudits = action.payload;
    },
    setAuditDetails(state, action) {
      state.auditDetails = action.payload; // Set audit details here
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    submitReport(state, action) {
      // Handle report submission logic (e.g., updating report status)
      state.reportStatus = 'submitted'; // Example: setting a report status after submission
    },
    resetReportStatus(state) {
      // Reset the report submission status if needed
      state.reportStatus = null;
    },
  },
});

export const { setAudits, setAuditDetails, setLoading,setUserAudits, setError, submitReport, resetReportStatus } = auditSlice.actions;
export default auditSlice.reducer;
